export const TASK_EXPIRATION_EMPTY_COUNTDOWN = '0 0 0 0';

export const TASK_EXPIRATION_EXPIRES_IN = 'The request expires in';
export const TASK_EXPIRATION_EXPIRED = 'The request has expired.';
export const TASK_EXPIRATION_EXPIRED_CONTACT_SCALAR = 'The request has expired. Contact Scalar to extend it.';

export const TASK_EXPIRATION_DAYS_LABEL = 'days';
export const TASK_EXPIRATION_HOURS_LABEL = 'hours';
export const TASK_EXPIRATION_MINUTES_LABEL = 'minutes';
export const TASK_EXPIRATION_SECONDS_LABEL = 'seconds';

export const TASK_EXPIRATION_EXTEND_BUTTON = 'Extend request';
export const TASK_EXPIRATION_EXTEND_DIALOG_TITLE = 'Extend request';
export const TASK_EXPIRATION_DATE_PICKER_LABEL = 'Expiration Date';
export const TASK_EXPIRATION_CANCEL = 'Cancel';
export const TASK_EXPIRATION_SAVE = 'Save';

export const TASK_EXPIRATION_EXTEND_SUCCESS = 'Request expiration date updated';
export const TASK_EXPIRATION_EXTEND_ERROR = 'Unable to extend this request';

export const TASK_EXPIRATION_EXTEND_BUTTON_ID = 'task-expiration-extend-button';
export const TASK_EXPIRATION_EXTEND_CONFIRM_ID = 'task-expiration-extend-confirm-button';
export const TASK_EXPIRATION_DATE_PICKER_ID = 'task-expiration-extend-date-picker';
